import React from 'react';
import { Container, Row, Col, Button, Alert, Spinner, Card } from 'react-bootstrap';
import { useAuth } from '../auth/AuthContext';
import useLearnerData from '../hooks/useLearnerData';
import LearnerNavbar from '../components/LearnerNavbar';
import AttendanceView from '../components/AttendanceView';
import '../styles/brand.css';

const LearnerAttendance = () => {
  const { currentUser, userProfile } = useAuth();
  const { attendance, attendanceSummary, pendingSessions, modules, loading, error, refresh } = useLearnerData(
    currentUser?.uid,
    userProfile
  );

  return (
    <>
      <LearnerNavbar />

      <section className="hero-section">
        <Container>
          <Row>
            <Col lg={8}>
              <h1 className="mb-3">Attendance Confirmation</h1>
              <p className="mission-text mb-4">
                Complete outstanding attendance registers and review your attendance history
              </p>
              <p className="mb-0">
                Review outstanding session dates, complete your attendance confirmations, and keep
                your learner attendance record up to date directly from the LMS.
              </p>
            </Col>
            <Col lg={4} className="d-flex align-items-center justify-content-end">
              <Button variant="light" onClick={refresh}>
                Refresh
              </Button>
            </Col>
          </Row>
        </Container>
      </section>

      <Container className="mt-4">
        {loading && (
          <div className="text-center py-5">
            <Spinner animation="border" role="status" variant="primary">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
            <p className="mt-3 text-muted">Loading attendance data...</p>
          </div>
        )}

        {!loading && error && (
          <Alert variant="danger">
            <strong>We couldn&apos;t load your attendance data.</strong>
            <div className="small mt-2">
              {error.message || 'Please refresh the page or try again later.'}
            </div>
          </Alert>
        )}

        {!loading && !error && (
          <Card className="shadow-sm border-0">
            <Card.Body>
              <AttendanceView
                attendanceRecords={attendance}
                attendanceSummary={attendanceSummary}
                pendingSessions={pendingSessions}
                modules={modules}
                onAttendanceSubmitted={refresh}
              />
            </Card.Body>
          </Card>
        )}
      </Container>
    </>
  );
};

export default LearnerAttendance;
